import React, { useState } from "react";
import {
  Box,
  Paper,
  Grid,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Neteisingas el. pašto formatas")
    .required("Laukas yra privalomas"),
  name: yup.string().required("Laukas yra privalomas"),
  phone: yup
    .string()
    .matches(
      /^[+]?[0-9]{0,15}$/,
      "Telefono numeris turi turėti iki 15 skaičių."
    )
    .optional(),
  company: yup.string().optional(),
  captcha: yup.string().required("Patvirtinkite, kad esate žmogus"),
});

const PdfForm = ({ calculatorData, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const totalSupply = calculatorData.summaryData.totalSupply;
  const totalExhaust = calculatorData.summaryData.totalExhaust;
  const totalRecuperators = calculatorData.summaryData.recuperators.length;

  const isVisible =
    totalSupply > 0 && totalExhaust > 0 && totalRecuperators > 0;

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    setValue("captcha", value);
    setCaptchaVerified(true);
  };

  const handleGeneratePdf = async (formData) => {
    setLoading(true);
    setMessage("");

    try {
      if (!calculatorData.selectedRecuperator) {
        setMessage("Prašome pasirinkti rekuperatorių.");
        setLoading(false);
        return;
      }

      await axios.post("/api/generate-pdf", {
        calculatorData,
        formData,
      });
      setMessage("");
      onSuccess();
    } catch (error) {
      console.error("Error generating PDF:", error);
      setMessage(error.response?.data?.message || "Klaida generuojant PDF.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box 
      sx={{
        p: 2,
        pt: 0,
        "@media (max-width: 600px)": {
          p: 1,
          pt: 0,
        },
      }}
    >
      {isVisible && (
        <Paper elevation={2} sx={{ 
          p: 2,
          "@media (max-width: 600px)": {
            p: 1,
          },
        }}>
          <Typography variant="h6" gutterBottom>
            Jūsų kontaktai:
          </Typography>
          <form onSubmit={handleSubmit(handleGeneratePdf)}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="El. pašto adresas *"
                      variant="outlined"
                      fullWidth
                      error={!!errors.email}
                      helperText={errors.email ? errors.email.message : ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="name"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Jūsų Vardas *"
                      variant="outlined"
                      fullWidth
                      error={!!errors.name}
                      helperText={errors.name ? errors.name.message : ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="phone"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Telefono numeris"
                      variant="outlined"
                      fullWidth
                      error={!!errors.phone}
                      helperText={errors.phone ? errors.phone.message : ""}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="company"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <TextField
                      {...field}
                      label="Įmonės pavadinimas"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                  onChange={handleCaptchaChange}
                />
                {errors.captcha && (
                  <Typography color="error">
                    {errors.captcha.message}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} textAlign="center">
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={loading || !captchaVerified}
                  style={{ padding: "10px 20px", fontSize: "16px" }}
                >
                  {loading ? (
                    <CircularProgress size={24} />
                  ) : (
                    "Atsisiųskite  PDF pasiūlymą"
                  )}
                </Button>
                {message && <Typography mt={2}>{message}</Typography>}
              </Grid>
            </Grid>
          </form>
        </Paper>
      )}
    </Box>
  );
};

export default PdfForm;
